import request from "@/utils/request";

export function getAction(url, data = {}, config = {}) {
  return request({
    url: url,
    method: "get",
    params: data,
    signal: config.signal // 取消请求
  });
}

export function postAction(url, data) {
  return request({
    url: url,
    method: "post",
    params: data
  });
}

export function postRequest(url, data) {
  return request({
    url: url,
    method: "post",
    data
  });
}

export function putAction(url, data) {
  return request({
    url: url,
    method: "put",
    data
  });
}

export function deleteAction(url, data) {
  return request({
    url: url,
    method: "delete",
    data
  });
}

export function downFile(url, data) {
  return request({
    url: url,
    method: "get",
    params: data,
    responseType: "blob"
  });
}

export function uploadAction(url, parameter) {
  return request({
    url: url,
    data: parameter,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}
